export const servicePartnersRoutes = {
  list: "",
  details: ":id",
  create: "new",
  edit: ":id/edit",
} as const;
